export default "__VITE_ASSET__CkRA8CXE__"